let bootstrapped = false;
let bootstrapPromise = null;
let bootstrapFailed = false;

export function isBootstrapComplete() {
  return bootstrapped;
}

export function hasBootstrapFailed() {
  return bootstrapFailed;
}

export function getBootstrapPromise() {
  return bootstrapPromise;
}

export function setBootstrapPromise(promise) {
  bootstrapPromise = promise;
}

export function markBootstrapSuccess() {
  bootstrapped = true;
  bootstrapFailed = false;
}

export function markBootstrapFailure() {
  bootstrapped = false;
  bootstrapFailed = true;
}

/** Clears bootstrap flags so the next sign-in re-hydrates Cognito groups from a fresh session. */
export function invalidateAuthBootstrap() {
  bootstrapped = false;
  bootstrapPromise = null;
  bootstrapFailed = false;
}

export function resetBootstrapForTesting() {
  invalidateAuthBootstrap();
}
